// Tracks mounted page loaders. mode 'full' = Capsule Corp screen allowed (episodes), 'poof' = capsule poof only
const active = { full: 0, poof: 0 };
const listeners = new Set();
const snapshot = () => ({ ...active });
const emit = () => listeners.forEach((l) => l(snapshot()));

export const loaderRegistry = {
  register(mode = 'poof') {
    active[mode] += 1;
    emit();
    return () => { active[mode] = Math.max(0, active[mode] - 1); emit(); };
  },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
  counts: snapshot,
};
